import '@fortawesome/fontawesome-svg-core/styles.css';
import './style/globalStyle.scss';

import { config as faConfig } from '@fortawesome/fontawesome-svg-core';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import NotFound from 'async!./routes/notFound';
import ContactUsModalLoader from 'Components/async/ContactUsModalLoader';
import InviteModalLoader from 'Components/async/InviteModalLoader';
import GuestOnlyGuard from 'Components/Authorize/GuestOnlyGuard';
import { Box, Grommet } from 'grommet';
import { grommet } from 'grommet/themes';
import { deepMerge } from 'grommet/utils';
import { useEffect, useErrorBoundary } from 'preact/hooks';
import Router from 'preact-router';
import { connect, Provider } from 'react-redux';
import { initializeGA, logPageViewGA } from 'Shared/ga';

import SurveyPopup from './components/modals/Survey/SurveyPopup';
import zoolifeTheme from './grommetTheme';
import { logAndGetCampaignData } from './helpers';
import { updateReferralData } from './redux/actions';
import store from './redux/store';
import Album from './routes/album';
import Gift from './routes/gift';
import LandingNew from './routes/landingNew';
import { initializeMP } from './shared/mp';

const homeTitle = "The world's first virtual zoo.";
const theme = deepMerge(grommet, zoolifeTheme);

// we are manually loading FA css and this should prevent duplication
faConfig.autoAddCss = false;

const Content = ({ showContactUs, updateReferralDataAction, showInvite }) => {
  useEffect(() => {
    const updateRefData = async () => {
      const campaignData = await logAndGetCampaignData();
      updateReferralDataAction(campaignData);
    };
    updateRefData();
  }, [updateReferralDataAction]);

  const routerChangeHandler = (props) => {
    const { url } = props;
    logPageViewGA(url);
    if (typeof window !== 'undefined' && window?.fbq) {
      window.fbq('track', 'PageView');
    }
  };

  useEffect(() => {
    initializeGA();
    initializeMP();
    if (typeof window !== 'undefined') {
      logPageViewGA(window.location.pathname);
    }
  }, []);

  const routes = (
    <Box fill className="calculated-full-height">
      <Router onRouteChange={routerChangeHandler}>
        <GuestOnlyGuard path="/" redirectRoute="/map" title={homeTitle}>
          <LandingNew />
        </GuestOnlyGuard>

        <Gift path="/gift" title="Gift Cards" />

        <Album mediaType="photos" path="/album/photos/:photoId" />
        <Album mediaType="videos" path="/album/videos/:videoId" />

        {/* NOTE: NotFound need to be at the end */}
        <NotFound path=":*" />
      </Router>

      <ContactUsModalLoader isOpen={showContactUs} />
      <SurveyPopup />
      <InviteModalLoader isOpen={showInvite} />
    </Box>
  );

  return (
    <Grommet full theme={theme} style={{ background: 'transparent' }}>
      {routes}
    </Grommet>
  );
};

const ConnectedContent = connect(
  ({
    modals: {
      contactus: { isOpen: showContactUs },
      invite: { isOpen: showInvite },
    },
  }) => ({ showContactUs, showInvite }),
  { updateReferralDataAction: updateReferralData },
)(Content);

const PublicPages = () => {
  useErrorBoundary((err) => {
    console.error(err);
    // TODO: log this somewhere (sentry, logRocket, or GA)
  });

  return (
    <Provider store={store}>
      <ConnectedContent />
    </Provider>
  );
};

export default PublicPages;
